export default function ErroePage() {
  return <div>404 no such route exists</div>;
}
